// extracted by mini-css-extract-plugin
export const practice = "g_N";
export const practice_heading = "g_P";
export const practice_inner = "g_Q";
export const practice_tabs = "g_R";
export const practice_link = "g_S";
export const practice_list = "g_T";
export const practice_item = "g_V";
export const practice_content = "g_W";
export const practice_content_list = "g_X";